import {z} from "zod";
import {ManagerInformationModel} from "../../tax-corporation";
import {HalfYearModel} from "./HalfYearModel";

const schema = z.object({
	department: z.string(),
	managerInformation: ManagerInformationModel.model.nullable(),
	halfYears: z.array(HalfYearModel.model),
	registrationTarget: z.number().nullable(),
	registrationActual: z.number().nullable(),
	registrationResultRate: z.number().nullable(),
	totalRegistrationRadio: z.number().nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantRegistrationModel = {schema, model};
export type ITaxAccountantRegistrationModel = z.infer<typeof TaxAccountantRegistrationModel.model>;
export const DEFAULT_TAX_ACCOUNTANT_REGISTRATION: ITaxAccountantRegistrationModel = {
	department: "",
	managerInformation: null,
	halfYears: [],
	registrationTarget: 0,
	registrationActual: 0,
	registrationResultRate: 0,
	totalRegistrationRadio: 0
};
